import * as z from "zod";

export const createAbTest = {
  name: "createAbTest" as const,
  input: z.object({
    type: z.enum(["imessage_channel"]),
    name: z.string().min(1).max(200),
  }),
  output: z.object({
    id: z.string(),
    type: z.enum(["imessage_channel"]),
    status: z.enum(["active", "ended"]),
    name: z.string(),
    startedAt: z.date(),
    endedAt: z.date().nullable(),
  }),
};
